import FeatureUpdateController from "../../../../components/feature_update_controller"

export default class extends FeatureUpdateController {
  static targets = ["organizationSelect"]

  initializeSelect2() {
    this.initializeEntitySelect2()
  }

  removeSelect2() {
    $(this.entitySelectTarget).select2("destroy")
    $(this.entitySelectTarget).val(null)
  }

  registerListeners() {
    $(this.entitySelectTarget).on("select2:select select2:clear", this.onEntitySelect.bind(this))
    if (this.hasOrganizationSelectTarget) {
      this.organizationSelectTarget.addEventListener("change", this.onOrganizationSelect.bind(this))
    }
  }

  removeListeners() {
    $(this.entitySelectTarget).off("select2:select select2:clear")
    if (this.hasOrganizationSelectTarget) {
      this.organizationSelectTarget.removeEventListener("change", this.onOrganizationSelect.bind(this))
    }
  }

  onOrganizationSelect() {
    this.clearEntitySelection()
  }

  get organizationId() {
    return this.hasOrganizationSelectTarget ? (this.organizationSelectTarget.value || null) : null
  }

  get formValid() {
    return this.fieldValid(this.entityId)
  }

  get parentModal() {
    return this.element.closest(".modal-dialog")
  }
}
